import React from 'react';
import {Box, Typography} from '@mui/material';
import {t} from '../../themes/statamicTokens';

const SectionCard = ({
    title,
    subtitle,
    actions,
    children,
    dense = false,
    sx,
}) => (
    <Box
        sx={{
            backgroundColor: t.color.surface,
            border: `1px solid ${t.color.border.default}`,
            borderRadius: `${t.radius.md}px`,
            overflow: 'hidden',
            ...sx,
        }}
    >
        {(title || actions) && (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    px: 2,
                    py: 1.5,
                    borderBottom: `1px solid ${t.color.border.hairline}`,
                }}
            >
                <Box sx={{minWidth: 0}}>
                    {title && (
                        <Typography
                            sx={{
                                fontSize: `${t.type.h3.size}px`,
                                fontWeight: t.type.h3.weight,
                                lineHeight: t.type.h3.lineHeight,
                                color: t.color.text.primary,
                            }}
                        >
                            {title}
                        </Typography>
                    )}
                    {subtitle && (
                        <Typography
                            sx={{
                                fontSize: `${t.type.caption.size}px`,
                                color: t.color.text.secondary,
                                mt: 0.25,
                            }}
                        >
                            {subtitle}
                        </Typography>
                    )}
                </Box>
                {actions && <Box sx={{display: 'flex', gap: 1, flexShrink: 0}}>{actions}</Box>}
            </Box>
        )}
        <Box sx={{p: dense ? 1.5 : 2}}>{children}</Box>
    </Box>
);

export default SectionCard;
